import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import withFieldSettings from '../../hocs/withFieldSettings'
import withHandleChange from '../../hocs/withHandleChange'
import { getAttributeType } from '../../utils/models'
import { getOptions } from '../../modules/options';
import File from '../../inputs/File'
import String from '../../inputs/String'
import Date from '../../inputs/Date'
import Text from '../../inputs/Text'
import Numeric from '../../inputs/Numeric'
import Switch from '../../inputs/Switch'
import Model from '../../inputs/Model'
import Select from '../../inputs/Select'
import Api from '../../inputs/Api'
import Time from '../../inputs/Time'
import Collection from '../../inputs/Collection'
import CollectionCheckbox from '../../inputs/Checkbox'
import CollectionRadio from '../../inputs/Radio'

class AutoInput extends Component {

    type() {
        return this.props.type || getAttributeType(this.props.model, this.props.attribute)
    }

    render() {
        switch (this.type()) {
            case 'file':
                return <File {...this.props} />

            case 'string':
                return <String {...this.props} />

            case 'date':
                return <Date {...this.props} />

            case 'datetime':
                return <Date dateTime {...this.props} />

            case 'text':
                return <Text {...this.props} />

            case 'number':
                return <Numeric {...this.props} />

            case 'currency':
                return <Numeric currency {...this.props} />

            case 'boolean':
                return <Switch {...this.props} />

            case 'model':
                if (this.props.model === 'profile') {
                    if (this.props.attribute === 'role')
                        return <CollectionRadio {...this.props} />
                    return <Select {...this.props} />
                }

                return <Model {...this.props} />

            case 'api':
                return <Api {...this.props} />

            case 'time':
                return <Time {...this.props} />

            case 'collection':
                if (this.props.model === 'dispatch') {
                    if (this.props.attribute === 'references' ||
                        this.props.attribute === 'items') {
                        return <Collection onlyNewItems {...this.props} />
                    }
                } else if (this.props.model === 'role') {
                    return <CollectionCheckbox {...this.props} />
                }

                return null

            default:
                return <String {...this.props} />
        }
    }
}

AutoInput.propTypes = {
    form: PropTypes.object.isRequired,
    model: PropTypes.string.isRequired,
    attribute: PropTypes.string.isRequired,
    value: PropTypes.any,
    id: PropTypes.number,
    belongsTo: PropTypes.object,
    hidden: PropTypes.bool
}



const mapStateToProps = state => ({
    options: state.options.options
  });

  const mapDispatchToProps = options =>
  bindActionCreators(
    {
      getOptions,
    },
    options
  );
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withFieldSettings(
    withHandleChange(AutoInput)
));



// WEBPACK FOOTER //
// ./src/containers/AutoInput/index.js